import { useState, useEffect, useCallback } from "react";
import axios from "../../api/axios";

export interface ProgramRun {
    run_id: number;
    run_title: string;
    start_date: string;
    end_date: string;
    status: "scheduled" | "active" | "completed" | "archived" | "paused";
    run_type: "quick" | "comprehensive";
    is_scope_verified: boolean;
    is_scope_submitted: boolean;
    settings_snapshot?: string;
    paused_at?: string;
    createdAt: string;
}

const useProgramRuns = (programId?: number) => {
    const [runs, setRuns] = useState<ProgramRun[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    const fetchRuns = useCallback(async () => {
        if (!programId) return;
        setIsLoading(true);
        try {
            const response = await axios.get(`/v2/programs/${programId}/runs`);
            setRuns(response.data.data || []);
            setError(null);
        } catch (err) {
            console.error("Error fetching runs:", err);
            setError(err);
            setRuns([]);
        } finally {
            setIsLoading(false);
        }
    }, [programId]);

    useEffect(() => {
        if (programId) {
            fetchRuns();
        }
    }, [programId, fetchRuns]);

    return { runs, isLoading, error, refetch: fetchRuns };
};

export default useProgramRuns;
